<div class="activity-drawer-shell cipx-form-container">
  <div class="activity-drawer-body cipx-scrollable-content">
    @if (accountOverviewLink) {
      <a class="activity-drawer-account-link" [routerLink]="accountOverviewLink">
        {{ accountLabel }}
      </a>
    }

    <sbd-doug-frontend-account-manager-activity-call-form
      [actorOptions]="actorOptions"
      [relatedRequestOptions]="relatedRequestOptions"
      [value]="callFormValue"
      (valueChange)="onCallFormValueChanged($event)"
      (relatedRequestSearch)="onRelatedRequestSearch($event)"></sbd-doug-frontend-account-manager-activity-call-form>
  </div>

  <sbd-doug-frontend-common-drawer-footer
    [buttons]="drawerFooterButtons"
    [buttonPosition]="'start'"
    [componentRef]="componentSelf"></sbd-doug-frontend-common-drawer-footer>
</div>
